export const DATA = [
	{
		id: "63c005f12077f943837551f7",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#4DB3FF",
		name: "Hill Lewis",
		gender: "male",
		company: "TWIGGERY",
		email: "hilllewis@twiggery.com",
		phone: "+1 (881) 578-2655",
		address: "271 Amersfort Place, Freeburn, Alaska, 2029",
		post: "Lorem est duis sit fugiat culpa nisi enim veniam elit incididunt eu. Magna commodo nostrud ipsum in id reprehenderit ut est cupidatat Lorem tempor exercitation pariatur culpa. Consequat exercitation quis esse ad cupidatat ea ex esse exercitation nisi enim exercitation id quis. Et duis tempor laborum reprehenderit commodo exercitation qui amet amet aliqua proident. Dolor proident fugiat cupidatat qui cupidatat nulla culpa id ut enim labore duis Lorem ut. Occaecat dolore ut in eiusmod do non est qui. Deserunt ex proident do magna.\r\n",
		date: "2022-05-09",
		tags: ["qui", "nisi", "fugiat", "amet", "amet", "nisi", "pariatur"],
	},
	{
		id: "63c005f14a5de1751c874531",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#3366E6",
		name: "Wade Poole",
		gender: "male",
		company: "MEDESIGN",
		email: "wadepoole@medesign.com",
		phone: "+1 (993) 461-2596",
		address: "601 Madison Place, Foscoe, Guam, 213",
		post: "Ut exercitation amet nulla deserunt commodo mollit. Do nulla nulla et fugiat. Ut voluptate quis commodo aute fugiat voluptate. Nulla do aliqua magna Lorem eiusmod cupidatat. Esse eiusmod esse incididunt veniam ut esse ad anim. Dolor ipsum eu pariatur magna dolor labore occaecat occaecat sunt mollit sint.\r\n",
		date: "2022-01-28",
		tags: ["elit", "aliquip", "amet", "qui", "pariatur", "deserunt", "duis"],
	},
	{
		id: "63c005f186b3b6b4c36d6767",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#66991A",
		name: "Cervantes Mendez",
		gender: "male",
		company: "ASSURITY",
		email: "cervantesmendez@assurity.com",
		phone: "+1 (926) 488-2971",
		address: "970 Chase Court, Trail, Wyoming, 6604",
		post: "Mollit duis nulla deserunt ut adipisicing et. Aliqua minim ullamco laborum ad. Quis culpa sit non mollit pariatur veniam fugiat. Enim anim commodo culpa ex velit eiusmod dolor reprehenderit incididunt sunt exercitation sit elit duis. Esse enim excepteur fugiat laborum ad occaecat consequat in sint. Enim minim voluptate labore eu culpa officia laboris nisi. Dolor reprehenderit magna ipsum sit pariatur cillum elit id.\r\n",
		date: "2022-05-04",
		tags: ["eiusmod", "consequat", "ut", "eu", "laborum", "tempor", "ut"],
	},
	{
		id: "63c005f1081754f77f6e485f",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#E666FF",
		name: "Frankie Leach",
		gender: "female",
		company: "MAKINGWAY",
		email: "frankieleach@makingway.com",
		phone: "+1 (969) 582-3447",
		address: "376 Vermont Street, Soham, Colorado, 3939",
		post: "Aliquip nulla exercitation reprehenderit laboris sint do Lorem voluptate enim ut est aute. Eiusmod fugiat qui minim ea sint quis velit. Ex reprehenderit id velit ad commodo et consequat tempor consectetur elit ut est ut Lorem.\r\n",
		date: "2022-02-04",
		tags: ["consequat", "aliquip", "minim", "incididunt", "do", "deserunt", "dolore"],
	},
	{
		id: "63c005f1be108fdacbc77153",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#999966",
		name: "Kristi Mccray",
		gender: "female",
		company: "DAYCORE",
		email: "kristimccray@daycore.com",
		phone: "+1 (842) 436-3326",
		address: "634 Ocean Avenue, Edinburg, Tennessee, 3111",
		post: "Id consectetur enim in ut occaecat incididunt nostrud qui. Anim dolor eu ex duis in enim non. Consectetur officia nulla ad irure nisi ea.\r\n",
		date: "2022-09-06",
		tags: ["tempor", "cupidatat", "occaecat", "qui", "veniam", "duis", "id"],
	},
	{
		id: "63c005f1baad8c338c3623b7",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#4D8066",
		name: "Park Horne",
		gender: "male",
		company: "EXOTERIC",
		email: "parkhorne@exoteric.com",
		phone: "+1 (857) 425-2164",
		address: "686 Borinquen Pl, Roy, Florida, 3752",
		post: "Voluptate in officia tempor consectetur incididunt. Consectetur ullamco amet duis proident veniam ex sint. Amet officia ad adipisicing voluptate magna. Dolore ex pariatur deserunt ex tempor ut voluptate nisi consectetur elit cupidatat. Lorem aliqua ullamco ullamco sunt duis amet ut laboris est adipisicing ea sit ex.\r\n",
		date: "2022-06-23",
		tags: ["commodo", "eu", "non", "deserunt", "sint", "qui", "consectetur"],
	},
	{
		id: "63c005f1ad9f8ef91a3d6642",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#CCCC00",
		name: "Twila Brady",
		gender: "female",
		company: "HELIXO",
		email: "twilabrady@helixo.com",
		phone: "+1 (932) 407-3097",
		address: "795 Newkirk Placez, Coventry, Federated States Of Micronesia, 8491",
		post: "Cillum dolor deserunt esse mollit cillum mollit deserunt et sint qui exercitation nostrud et. Duis cupidatat esse dolor deserunt enim ea duis pariatur eiusmod pariatur eiusmod. Cillum voluptate eiusmod sint velit duis sint.\r\n",
		date: "2022-01-21",
		tags: ["ex", "ut", "exercitation", "proident", "occaecat", "laborum", "labore"],
	},
	{
		id: "63c005f12fdc1cf14fcd4697",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#4DB380",
		name: "Amy Kim",
		gender: "female",
		company: "PUSHCART",
		email: "amykim@pushcart.com",
		phone: "+1 (965) 561-2643",
		address: "655 Havens Place, Rivera, Nevada, 4361",
		post: "Adipisicing sit est Lorem sunt aliquip eiusmod consequat consectetur consequat nisi Lorem id mollit dolore. Voluptate laborum ullamco eiusmod eu enim. Cillum velit excepteur eiusmod incididunt. Dolore ipsum esse sit cillum ullamco qui laboris.\r\n",
		date: "2022-06-25",
		tags: ["eu", "irure", "consequat", "voluptate", "reprehenderit", "pariatur", "deserunt"],
	},
	{
		id: "63c005f120542c6dca833d75",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#00E680",
		name: "Joyce Stephenson",
		gender: "male",
		company: "BILLMED",
		email: "joycestephenson@billmed.com",
		phone: "+1 (990) 487-3028",
		address: "961 Eaton Court, Canby, Maryland, 6942",
		post: "Reprehenderit exercitation amet do excepteur consectetur excepteur adipisicing ipsum exercitation amet labore dolor ad culpa. Lorem minim fugiat aliqua laborum fugiat ex deserunt. Eu anim elit anim irure. Veniam culpa officia officia voluptate commodo ut officia. Reprehenderit non qui irure eiusmod aliqua.\r\n",
		date: "2022-02-27",
		tags: ["aliquip", "aute", "amet", "Lorem", "eiusmod", "irure", "occaecat"],
	},
	{
		id: "63c005f1eae814ca5297121e",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#B33300",
		name: "Renee Cash",
		gender: "female",
		company: "MAGNINA",
		email: "reneecash@magnina.com",
		phone: "+1 (996) 469-3616",
		address: "729 Caton Avenue, Cutter, Maine, 6122",
		post: "Cupidatat labore id qui ipsum consequat esse qui proident irure est. Laborum deserunt minim excepteur esse ullamco eu nostrud Lorem magna irure ea velit mollit. Nulla labore cupidatat ea elit id proident id sint aute esse quis incididunt exercitation sit. Minim Lorem laboris aliquip ea laboris commodo magna.\r\n",
		date: "2022-09-28",
		tags: ["fugiat", "do", "labore", "Lorem", "incididunt", "culpa", "proident"],
	},
	{
		id: "63c005f11137a3cf712a9490",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#FFFF99",
		name: "Jan Yang",
		gender: "female",
		company: "AFFLUEX",
		email: "janyang@affluex.com",
		phone: "+1 (855) 444-3894",
		address: "984 Mill Avenue, Kingstowne, Indiana, 4877",
		post: "Id do cupidatat eu ex proident. Enim minim aliqua pariatur consequat exercitation tempor non consequat id. Cillum culpa ipsum dolor id esse Lorem nisi excepteur in eu. Pariatur exercitation amet nisi cillum esse nostrud irure eu non deserunt. Sit ullamco Lorem incididunt ullamco aute culpa ex Lorem proident consequat excepteur. Labore nisi nisi ad qui laborum id. Eiusmod deserunt labore adipisicing labore deserunt Lorem fugiat excepteur consectetur ipsum elit qui amet.\r\n",
		date: "2022-12-07",
		tags: [
			"exercitation",
			"enim",
			"aliqua",
			"exercitation",
			"excepteur",
			"occaecat",
			"adipisicing",
		],
	},
	{
		id: "63c005f1105735d35543e098",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#00E680",
		name: "England Oneil",
		gender: "male",
		company: "HIVEDOM",
		email: "englandoneil@hivedom.com",
		phone: "+1 (880) 522-2246",
		address: "795 Crawford Avenue, Emory, Vermont, 8838",
		post: "Laborum veniam proident sunt sint sit nulla esse id consequat tempor minim ad nulla duis. Mollit tempor et quis commodo dolor exercitation deserunt magna excepteur. Commodo reprehenderit eiusmod sunt qui consectetur dolor veniam excepteur in nisi.\r\n",
		date: "2022-02-18",
		tags: ["nostrud", "ullamco", "mollit", "esse", "anim", "labore", "sunt"],
	},
	{
		id: "63c005f16a93f0ca8fa884ee",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#6680B3",
		name: "Daniel Reilly",
		gender: "male",
		company: "ECLIPSENT",
		email: "danielreilly@eclipsent.com",
		phone: "+1 (873) 478-2734",
		address: "475 Clarkson Avenue, Charco, Georgia, 6608",
		post: "Eu dolor irure dolor laboris pariatur esse esse nulla ea aute sunt mollit consequat. Deserunt ea mollit cupidatat enim ullamco excepteur sit enim mollit ipsum magna. Magna consequat officia ullamco enim mollit pariatur magna laborum. Ut ut aliqua do voluptate qui culpa mollit irure labore cupidatat dolore reprehenderit. Duis anim nisi dolore minim est id adipisicing cupidatat sunt nisi deserunt fugiat eiusmod. Do reprehenderit aute ex id cupidatat laboris adipisicing sit dolore.\r\n",
		date: "2022-11-14",
		tags: ["aliquip", "irure", "amet", "tempor", "reprehenderit", "ullamco", "cupidatat"],
	},
	{
		id: "63c005f1cde8e3a9673f9e22",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#B34D4D",
		name: "Coleman Goff",
		gender: "male",
		company: "QUILITY",
		email: "colemangoff@quility.com",
		phone: "+1 (817) 434-2797",
		address: "853 Gaylord Drive, Nadine, Michigan, 2340",
		post: "Nisi incididunt eu voluptate reprehenderit eiusmod elit ut tempor qui Lorem non exercitation officia. Dolore pariatur aliqua cupidatat minim adipisicing qui incididunt voluptate aliqua. Magna duis consequat aliqua voluptate officia aliqua cillum. Labore esse labore dolore ad culpa dolor aliqua magna excepteur. Nisi et elit qui ipsum dolor deserunt commodo qui excepteur quis sunt. Commodo non elit irure id quis dolor irure culpa fugiat magna.\r\n",
		date: "2023-01-08",
		tags: ["enim", "incididunt", "officia", "amet", "minim", "commodo", "id"],
	},
	{
		id: "63c005f1b3f4809508303d8f",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#FF99E6",
		name: "Brandy Love",
		gender: "female",
		company: "BIOTICA",
		email: "brandylove@biotica.com",
		phone: "+1 (959) 450-2556",
		address: "894 Stewart Street, Titanic, Palau, 7889",
		post: "Eu in officia Lorem officia nostrud aliquip aute sit cupidatat mollit incididunt consectetur ullamco fugiat. Commodo cupidatat cillum ut qui velit incididunt id aliqua fugiat laboris. Laboris magna laborum officia sunt tempor fugiat ea sunt cillum ut.\r\n",
		date: "2022-01-30",
		tags: ["Lorem", "cupidatat", "ullamco", "adipisicing", "nulla", "ipsum", "aliqua"],
	},
	{
		id: "63c005f1bfeed03d7dce455d",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#4D8066",
		name: "Jeannette Jacobson",
		gender: "female",
		company: "FANGOLD",
		email: "jeannettejacobson@fangold.com",
		phone: "+1 (943) 514-2720",
		address: "307 Harbor Lane, Bynum, North Dakota, 4603",
		post: "Lorem laborum ut ullamco id velit proident amet enim reprehenderit commodo sunt. Exercitation ipsum ea et et nulla enim enim nostrud aliqua exercitation amet Lorem. Fugiat officia duis officia labore.\r\n",
		date: "2022-07-05",
		tags: ["adipisicing", "aliquip", "enim", "nulla", "aute", "dolore", "ea"],
	},
	{
		id: "63c005f17910268496b86f32",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#E6B3B3",
		name: "Annette Booker",
		gender: "female",
		company: "SPLINX",
		email: "annettebooker@splinx.com",
		phone: "+1 (864) 425-2831",
		address: "130 Cox Place, Orovada, Kansas, 4533",
		post: "Occaecat eu cupidatat consequat incididunt tempor sunt mollit. Minim id velit tempor deserunt consectetur ipsum tempor consectetur tempor consequat nisi eu velit. Eiusmod ipsum nulla voluptate incididunt proident ipsum duis cillum culpa consequat quis laborum. In commodo veniam ullamco sit elit sint tempor consequat id ipsum ut. Enim do pariatur irure adipisicing sit exercitation tempor veniam Lorem. Laboris amet consequat sit fugiat commodo duis dolore elit.\r\n",
		date: "2022-01-01",
		tags: ["aliquip", "occaecat", "et", "enim", "veniam", "commodo", "consequat"],
	},
	{
		id: "63c005f13871858bec3280d7",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#4DB380",
		name: "Barrera Mullen",
		gender: "male",
		company: "VIOCULAR",
		email: "barreramullen@viocular.com",
		phone: "+1 (985) 405-3615",
		address: "504 Olive Street, Gardiner, Nebraska, 6685",
		post: "Veniam exercitation dolor cupidatat velit deserunt ipsum minim laboris. Adipisicing exercitation esse ad laboris. Ullamco laboris aute nostrud aliqua officia.\r\n",
		date: "2022-04-04",
		tags: ["do", "mollit", "sunt", "eiusmod", "mollit", "proident", "aute"],
	},
	{
		id: "63c005f181d8a8043c5d6d44",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#FF33FF",
		name: "Sharron Mcgowan",
		gender: "female",
		company: "VERAQ",
		email: "sharronmcgowan@veraq.com",
		phone: "+1 (996) 554-2000",
		address: "319 Metrotech Courtr, Rivers, American Samoa, 935",
		post: "Laboris exercitation aute adipisicing ut laborum id laboris Lorem sint. Officia sunt aliqua voluptate velit. Ea anim exercitation incididunt culpa commodo anim cillum ex exercitation. Culpa ea laborum id et exercitation officia et nisi do aliqua consectetur. Deserunt cillum id adipisicing dolore ea nisi cillum occaecat quis aliquip proident velit.\r\n",
		date: "2022-11-12",
		tags: ["dolore", "cillum", "nulla", "nostrud", "laborum", "eu", "enim"],
	},
	{
		id: "63c005f131112714d74d1809",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#6666FF",
		name: "Valarie Burch",
		gender: "female",
		company: "HONOTRON",
		email: "valarieburch@honotron.com",
		phone: "+1 (890) 570-3799",
		address: "731 Vanderveer Street, Chloride, Ohio, 8181",
		post: "Ipsum velit tempor quis nisi non. Cillum quis nulla pariatur ad eiusmod laboris excepteur tempor. Mollit incididunt proident consectetur proident anim. Commodo do irure incididunt eiusmod aute nostrud ea esse ad cupidatat cupidatat labore. Id commodo quis duis consequat culpa aute velit irure.\r\n",
		date: "2022-10-08",
		tags: ["eiusmod", "veniam", "sunt", "aliqua", "occaecat", "cillum", "exercitation"],
	},
	{
		id: "63c005f1ff5f99c384e90d6f",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#E666FF",
		name: "Stout Hart",
		gender: "male",
		company: "TALAE",
		email: "stouthart@talae.com",
		phone: "+1 (956) 530-2769",
		address: "823 Tudor Terrace, Lindisfarne, Delaware, 5059",
		post: "Adipisicing est deserunt nisi qui nisi cupidatat excepteur. Exercitation enim ipsum ut eu nostrud magna aliquip. Consectetur duis minim ex ullamco non minim dolore quis. Cupidatat veniam occaecat aliqua ea voluptate nulla. Aliqua consequat ut sit pariatur. Nulla in cillum fugiat ut nisi anim nisi tempor. Ullamco officia et laborum qui anim voluptate enim excepteur ut dolor nisi commodo voluptate velit.\r\n",
		date: "2022-03-26",
		tags: ["sint", "quis", "velit", "labore", "laboris", "deserunt", "qui"],
	},
	{
		id: "63c005f11b288ab722e36e33",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#00B3E6",
		name: "Charles Rosa",
		gender: "male",
		company: "ZIORE",
		email: "charlesrosa@ziore.com",
		phone: "+1 (934) 438-3347",
		address: "782 McKinley Avenue, Martinez, Connecticut, 7532",
		post: "Enim non excepteur aute incididunt eu anim velit do labore voluptate ipsum id. Voluptate amet duis anim anim et. Ex id cupidatat cillum aute ad dolor exercitation laborum pariatur consequat dolor culpa do.\r\n",
		date: "2022-04-06",
		tags: ["ex", "dolore", "ullamco", "quis", "culpa", "ad", "proident"],
	},
	{
		id: "63c005f1524f590d99c9850f",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#1AB399",
		name: "Cash Taylor",
		gender: "male",
		company: "INSURETY",
		email: "cashtaylor@insurety.com",
		phone: "+1 (953) 427-2958",
		address: "335 Metropolitan Avenue, Fostoria, West Virginia, 2666",
		post: "Excepteur incididunt laborum sit proident esse Lorem sint. Dolore ipsum Lorem quis ad pariatur quis dolore qui. Ullamco eu ullamco mollit ut Lorem veniam. Amet consectetur enim enim in nulla adipisicing duis. Duis aute duis excepteur minim occaecat est id sunt velit non duis qui do. Nostrud nulla occaecat anim voluptate aute do cillum tempor qui.\r\n",
		date: "2022-12-23",
		tags: ["reprehenderit", "aute", "magna", "quis", "enim", "excepteur", "cupidatat"],
	},
	{
		id: "63c005f1e70925a9d869e457",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#FF4D4D",
		name: "Cunningham Craft",
		gender: "male",
		company: "ZEAM",
		email: "cunninghamcraft@zeam.com",
		phone: "+1 (893) 542-2952",
		address: "731 Fillmore Avenue, Cartwright, Marshall Islands, 5314",
		post: "Dolore elit cillum officia ex voluptate irure eu ullamco. Velit cillum et cupidatat deserunt ut anim sint sunt voluptate laborum. Occaecat aliquip ipsum adipisicing pariatur ea est fugiat pariatur. Proident consequat qui adipisicing ea dolore eu ea officia fugiat laboris mollit consectetur occaecat veniam. Aliqua tempor ipsum labore velit non quis do voluptate duis dolor occaecat in. Eu non culpa officia amet ullamco qui nostrud exercitation amet elit non. Aliquip elit et laborum fugiat culpa consequat cillum culpa cillum.\r\n",
		date: "2022-09-24",
		tags: ["in", "consequat", "exercitation", "consequat", "qui", "magna", "irure"],
	},
	{
		id: "63c005f12736e532a8662c48",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#809980",
		name: "Singleton Quinn",
		gender: "male",
		company: "KONGLE",
		email: "singletonquinn@kongle.com",
		phone: "+1 (808) 518-3214",
		address: "402 Devon Avenue, Noxen, Missouri, 9216",
		post: "Aliqua tempor Lorem sit non eiusmod occaecat et tempor nostrud quis elit. Minim quis eiusmod velit qui aliqua veniam exercitation. Nostrud esse amet ullamco exercitation in sint eu Lorem ullamco est occaecat id. Incididunt ut labore adipisicing velit sit non enim.\r\n",
		date: "2022-05-31",
		tags: ["tempor", "cupidatat", "enim", "nostrud", "est", "proident", "magna"],
	},
	{
		id: "63c005f101b80f18b99c2582",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#991AFF",
		name: "Macias Phillips",
		gender: "male",
		company: "GROK",
		email: "maciasphillips@grok.com",
		phone: "+1 (833) 538-3954",
		address: "167 Aviation Road, Harold, New Jersey, 6774",
		post: "Reprehenderit est ad enim proident ad ut irure duis et aliquip. Amet culpa labore non in occaecat anim. Labore nulla voluptate dolor adipisicing minim ad nulla tempor culpa et occaecat. Amet quis sit veniam fugiat elit ut dolor quis. Commodo aute in fugiat dolore eu officia magna non veniam sit esse ipsum. Ut ullamco nulla eu incididunt elit.\r\n",
		date: "2022-11-11",
		tags: ["incididunt", "nostrud", "eiusmod", "excepteur", "esse", "veniam", "pariatur"],
	},
	{
		id: "63c005f1087a016fcb77f25a",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#FF4D4D",
		name: "Richardson Rasmussen",
		gender: "male",
		company: "AQUAMATE",
		email: "richardsonrasmussen@aquamate.com",
		phone: "+1 (990) 475-2796",
		address: "679 Grand Avenue, Eastvale, Virginia, 5332",
		post: "Eu esse sint officia incididunt adipisicing. Ea et sunt laborum nulla do cupidatat nisi anim irure commodo nulla exercitation aliqua magna. Magna magna ad consectetur magna ad deserunt.\r\n",
		date: "2022-02-16",
		tags: ["dolor", "magna", "sunt", "culpa", "Lorem", "dolor", "ad"],
	},
	{
		id: "63c005f19d4cd33ee041df62",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#FF99E6",
		name: "Joanne Jones",
		gender: "female",
		company: "FLUMBO",
		email: "joannejones@flumbo.com",
		phone: "+1 (911) 505-2176",
		address: "588 Beaver Street, Connerton, Illinois, 6396",
		post: "Cillum Lorem nulla eiusmod cillum cillum. Ea nulla amet tempor sit. Cupidatat veniam consequat reprehenderit et ex proident velit consequat labore duis velit voluptate id pariatur. Reprehenderit eiusmod anim enim minim incididunt.\r\n",
		date: "2023-01-05",
		tags: ["commodo", "fugiat", "est", "ad", "commodo", "qui", "do"],
	},
	{
		id: "63c005f10d6b6dee5793426f",
		imageUrl: "https://images.pexels.com/photos/1655901/pexels-photo-1655901.jpeg",
		color: "#E666FF",
		name: "Britt Watkins",
		gender: "male",
		company: "ENERSAVE",
		email: "brittwatkins@enersave.com",
		phone: "+1 (933) 598-3907",
		address: "312 Woodside Avenue, Tilleda, Alabama, 7452",
		post: "Excepteur commodo velit dolore in qui labore cupidatat occaecat qui consequat qui anim. Est aute minim ea exercitation enim labore minim velit anim ullamco excepteur adipisicing. Labore deserunt et dolore culpa ex non dolore excepteur sint laboris id. Dolor sit laboris occaecat eu. Quis est Lorem in occaecat incididunt magna do exercitation ex consectetur sunt. Incididunt consectetur ex fugiat dolor eu id eu et do dolore deserunt eiusmod.\r\n",
		date: "2022-11-10",
		tags: ["laborum", "nisi", "excepteur", "veniam", "quis", "in", "ipsum"],
	},
];

export const PHOTOS = [
	{
		img: "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e",
		title: "Breakfast",
		rows: 2,
		cols: 2,
	},
	{
		img: "https://images.unsplash.com/photo-1551782450-a2132b4ba21d",
		title: "Burger",
	},
	{
		img: "https://images.unsplash.com/photo-1522770179533-24471fcdba45",
		title: "Camera",
	},
	{
		img: "https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c",
		title: "Coffee",
		cols: 2,
	}
];
